import React from "react";
import "./Menu.scss";
import { Link, useNavigate } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";

const Menu = ({
  projects = [],
  categories = [],
  setSlider,
  informations = [],
  setShowInfoGlobal,
  setActiveInfoIds,
  activeInfoIds = [],
  setIsInfoExpanded,
  showInfo,
  setShowInfo,
  showTypes,
  setShowTypes,
  selectedType,
  setSelectedType,
}) => {
  const { language, prevLanguage, isFading } = useLanguage();
  const navigate = useNavigate();

  const handleProjectClick = () => {
    setShowTypes(!showTypes);
    if (!showTypes) {
      if (setShowInfo) setShowInfo(false);
      if (setIsInfoExpanded) setIsInfoExpanded(false);
      if (setShowInfoGlobal) setShowInfoGlobal(false);
      if (setActiveInfoIds) setActiveInfoIds([]);
    }
    if (showTypes) setSelectedType(null);
  };

  const handleInfoClick = () => {
    const newState = !showInfo;
    if (setShowInfo) setShowInfo(newState);
    if (newState) {
      setShowTypes(false);
      setSelectedType(null);
      navigate("/info");
    }
    if (setShowInfoGlobal) setShowInfoGlobal(newState);
    if (!newState && setActiveInfoIds) {
      setActiveInfoIds([]);
      if (setIsInfoExpanded) setIsInfoExpanded(false);
    }
  };

  const handleInfoItemClick = (id) => {
    if (setActiveInfoIds) {
      setActiveInfoIds((prev) => {
        const isCurrentlyActive = prev.includes(id);
        let nextActiveIds;

        if (window.innerWidth <= 768) {
          nextActiveIds = isCurrentlyActive ? [] : [id];
        } else {
          nextActiveIds = isCurrentlyActive
            ? prev.filter((itemId) => itemId !== id)
            : [...prev, id];
        }

        if (setIsInfoExpanded) {
          setIsInfoExpanded(nextActiveIds.length > 0);
        }

        return nextActiveIds;
      });
    }
  };

  const handleTypeClick = (type) => {
    setSelectedType(selectedType === type ? null : type);
  };

  const isBioOpen = activeInfoIds.includes("41d85557-c540-411f-9eea-dd8a964aac68");

  return (
    <div
      className={`menu ${isBioOpen ? "bio-open" : ""} ${isFading ? "is-fading" : ""}`}
    >
      <div className="menu-projects">
        <p onClick={handleProjectClick} className="menu-trigger">
          <span className="lang-current">
            {language === "fr" ? "Réalisations" : "Creations"}
          </span>
          {isFading && (
            <span className="lang-prev">
              {prevLanguage === "fr" ? "Réalisations" : "Creations"}
            </span>
          )}
        </p>

        {showTypes && (
          <div className="menu-projects-types">
            {[...categories]
              .sort((a, b) => (a.fields?.ordre || 0) - (b.fields?.ordre || 0))
              .map((cat, idx) => {
                const displayTitle = language === "en" && cat.fields?.titleEn ? cat.fields.titleEn : cat.fields?.titre;
                return (
                <div key={`cat-${idx}`} className="type-group">
                  <Link
                    to={`/${cat.fields?.url}`}
                    className="type-item"
                    onClick={() => {
                      if (setActiveInfoIds) setActiveInfoIds([]);
                      if (setShowInfoGlobal) setShowInfoGlobal(false);
                      if (setIsInfoExpanded) setIsInfoExpanded(false);
                      if (setShowInfo) setShowInfo(false);
                    }}
                  >
                    {displayTitle}
                  </Link>
                </div>
              );
              })}

            {/* Hardcoded "In situ" category since it aggregates all top-level projects, or if it has projects let's display them */}
            {projects.length > 0 && (
              <div className="type-group">
                <p
                  className="type-item"
                  onClick={() => handleTypeClick("in-situ")}
                >
                  <span className="lang-current">
                    {language === "fr" ? "In situ" : "In situ"}
                  </span>
                  {isFading && (
                    <span className="lang-prev">
                      {prevLanguage === "fr" ? "In situ" : "In situ"}
                    </span>
                  )}
                </p>
                {selectedType === "in-situ" && (
                  <div className="type-projects">
                    {[...projects]
                      .sort((a, b) => (a.fields?.ordre || 0) - (b.fields?.ordre || 0))
                      .map((p, pIdx) => {
                        const displayTitle = language === "en" && p.fields?.titleEn ? p.fields.titleEn : p.fields?.titre;
                        return (
                        <Link
                          key={`proj-${pIdx}`}
                          to={`/${p.fields?.url}`}
                          className="project-title-item"
                          onClick={() => {
                            if (setActiveInfoIds) setActiveInfoIds([]);
                            if (setShowInfoGlobal) setShowInfoGlobal(false);
                            if (setIsInfoExpanded) setIsInfoExpanded(false);
                            setShowInfo(false);
                          }}
                        >
                          {displayTitle}
                        </Link>
                      );
                      })}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      <div className="menu-info">
        <p onClick={handleInfoClick} className="menu-trigger">
          <span className="lang-current">
            {language === "fr" ? "Informations" : "Information"}
          </span>
          {isFading && (
            <span className="lang-prev">
              {prevLanguage === "fr" ? "Informations" : "Information"}
            </span>
          )}
        </p>
        {showInfo && (
          <div className="menu-info-types">
            {[...informations]
              .sort((a, b) => (a.fields?.ordre || 0) - (b.fields?.ordre || 0))
              .filter((info) => info.sys?.id !== "aec6f233-1aac-4c3e-909c-b4f443e2d3ba")
              .map((info, idx) => {
                const isActive = activeInfoIds.includes(info.sys?.id);
                const pdfUrl = info.fields?.pdf?.fields?.file?.url;
                const displayTitle = language === "en" && info.fields?.titleEn ? info.fields.titleEn : info.fields?.titre;
                if (pdfUrl) {
                  const fullUrl = pdfUrl.startsWith("http")
                    ? pdfUrl
                    : `https:${pdfUrl}`;
                  return (
                    <a
                      key={idx}
                      className="info-item"
                      href={fullUrl}
                      download
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {displayTitle}
                    </a>
                  );
                }
                return (
                  <p
                    key={idx}
                    className={`info-item ${isActive ? "active" : ""}`}
                    onClick={() => handleInfoItemClick(info.sys?.id)}
                  >
                    {displayTitle}
                  </p>
                );
              })}
          </div>
        )}
      </div>
    </div>
  );
};

export default Menu;
